import { render, staticRenderFns } from "./dianwei-add.vue?vue&type=template&id=3e18531c&scoped=true&"
import script from "./dianwei-add.vue?vue&type=script&lang=js&"
export * from "./dianwei-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e18531c",
  null
  
)

export default component.exports